import { render } from "./statusTag.vue?vue&type=template&id=7f17ec8d"
import script from "./statusTag.vue?vue&type=script&lang=js"
export * from "./statusTag.vue?vue&type=script&lang=js"

import "./statusTag.vue?vue&type=style&index=0&id=7f17ec8d&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__